<template>
  <div class="app-right-main">
    <div class="app-right-top-header">
      <div class="vertical-center header-content">
        设备型号：<el-select
          size="mini"
          class="select"
          v-model="value"
          filterable
          @change="fetchData"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button
          v-permission="'upload_dial_file'"
          type="primary"
          size="small"
          @click="uploadDialFile"
          class="add-button"
        >
          上传表盘文件
        </el-button>
      </div>
    </div>
    <div class="app-right-table-content">
      <el-table
        :data="dialList"
        :border="true"
        stripe
        show-overflow-tootip="true"
      >
        <el-table-column align="center" label="设备型号" prop="model">
          <template slot-scope="scope">
            {{ options.find((t) => t.value === scope.row.model)?.label }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="表盘ID" prop="dialPos">
          <!-- <template slot-scope="scope">
            {{ scope.row.dialPos }}
          </template> -->
        </el-table-column>
        <el-table-column align="center" label="图片" prop="picture">
          <template slot-scope="scope">
            <img
              :src="scope.row.picture"
              alt=""
              style="width: 80px; height: 80px"
            />
          </template>
        </el-table-column>
        <el-table-column align="center" label="表盘名称" prop="name">
        </el-table-column>
        <el-table-column align="center" label="文件名" prop="fileName">
        </el-table-column>
        <el-table-column align="center" label="是否预置表盘" prop="preset">
          <template slot-scope="scope">
            {{ scope.row.preset ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="文件大小" prop="size">
          <template slot-scope="scope">
            {{ dealSize(scope.row.size) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          v-if="editFlag || removeFlag"
          label="更新时间"
          prop="lastModifyTime"
        >
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              v-permission="'dial_edit'"
              @click.native.prevent="editDial(scope.row)"
              >编辑
            </el-button>
            <el-button
              v-if="!scope.row.preset"
              v-permission="'dial_del'"
              type="text"
              size="small"
              @click.native.prevent="deleteDial(scope.row)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :title="op === 'add' ? '添加表盘' : '编辑表盘'"
      :visible.sync="dialDialogVisible"
      @close="closeDialDialog"
    >
      <add-dial-form
        :dialog-visible="dialDialogVisible"
        :data="raw"
        :op="op"
        @clickCancel="dialDialogVisible = false"
        @successCreateDial="successCreateDialAction"
        ref="addDial"
      ></add-dial-form>
    </el-dialog>

    <div class="dial-pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 20, 50, 100, 200, 300, 400]"
        :page-size="size"
        layout="sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getDialList, deleteDial } from "../../api/dialApi";
import { dealSize } from "../../utils/util";
import { handleResponse } from "../../utils/response";
import AddDialForm from "./addDialForm";

export default {
  name: "DialList",
  components: {
    AddDialForm,
  },
  props: {},
  mounted() {
    this.getDialList(this.page, this.size);
  },
  created() {},
  watch: {},

  computed: {
    uploadFlag() {
      //上传表盘权限管理
      return (
        this.$store.state.userInfo.permissions.includes("addDial") ||
        this.$store.getters.isAdmin
      );
    },
    editFlag() {
      //编辑表盘权限管理
      return (
        this.$store.state.userInfo.permissions.includes("updateDial") ||
        this.$store.getters.isAdmin
      );
    },
    removeFlag() {
      //删除表盘权限管理
      return (
        this.$store.state.userInfo.permissions.includes("deleteDial") ||
        this.$store.getters.isAdmin
      );
    },
  },
  methods: {
    /** 转换文件大小 */
    dealSize(num) {
      return dealSize(num);
    },
    successCreateDialAction() {
      this.dialDialogVisible = false;
      this.addSuccess = true;
    },
    /**
     * 关闭弹出框 统一操作
     */
    closeDialDialog() {
      this.$refs.addDial.clearData();
      if (this.op === "add" && this.addSuccess) {
        this.page = 1;
        this.getDialList(1, this.size);
      } else {
        this.getDialList(this.page, this.size);
      }
      this.dialDialogVisible = false;
      this.addSuccess = false;
    },
    /**
     * 上传DIAL文件，打开对话框
     */
    uploadDialFile() {
      this.op = "add";
      this.raw = {};
      this.dialDialogVisible = true;
    },
    /** 编辑表盘 */
    editDial(raw) {
      this.op = "edit";
      const r = JSON.stringify(raw);
      this.raw = JSON.parse(r);
      this.dialDialogVisible = true;
    },
    getDialList(page, size, model) {
      getDialList(page, size, model).then((response) => {
        handleResponse(
          response,
          (data) => {
            this.dialList = data.list;
            this.total = data.total * data.size; // total是页数;
          },
          (error) => {}
        );
      });
    },
    deleteDial(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteDial({ id: row.id }).then((response) => {
            handleResponse(
              response,
              (data) => {
                this.getDialList(this.page, this.size);
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              },
              (error) => {
                this.getDialList(this.page, this.size);
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
            );
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.size = val;
      this.getDialList(this.page, val, this.value);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getDialList(val, this.size, this.value);
    },
    // 筛选表格
    fetchData() {
      this.getDialList(this.page, this.size, this.value);
    },
  },
  data() {
    return {
      value: "",
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "Y001S",
        },
        {
          value: 1,
          label: "Y006",
        },
        {
          value: 2,
          label: "Y908S",
        },
        {
          value: 3,
          label: "Y007",
        },
        {
          value: 4,
          label: "Y003",
        },
      ],
      raw: {},
      dialDialogVisible: false,
      dialList: [],
      page: 1,
      total: 1,
      size: 5,
      op: "add",
      addSuccess: false,
    };
  },
};
</script>

<style scoped>
.dial-pagination {
  margin-top: 20px;
  text-align: right;
  margin-right: 10px;
}
.add-button {
  margin-left: 20px;
  /* float: right; */
}
.select {
  width: 200px;
}
</style>
